export var LuxStatusEnum;
(function (LuxStatusEnum) {
    LuxStatusEnum["primary"] = "primary";
    LuxStatusEnum["secondary"] = "secondary";
    LuxStatusEnum["tertiary"] = "tertiary";
    LuxStatusEnum["success"] = "success";
    LuxStatusEnum["info"] = "info";
    LuxStatusEnum["warning"] = "warning";
    LuxStatusEnum["danger"] = "danger";
    LuxStatusEnum["gray"] = "gray";
    LuxStatusEnum["dark"] = "dark";
})(LuxStatusEnum || (LuxStatusEnum = {}));
export var LuxStatusV2Enum;
(function (LuxStatusV2Enum) {
    // tertiary = 'tertiary',
    LuxStatusV2Enum["primary"] = "primary";
    LuxStatusV2Enum["secondary"] = "secondary";
    LuxStatusV2Enum["success"] = "success";
    LuxStatusV2Enum["info"] = "info";
    LuxStatusV2Enum["warning"] = "warning";
    LuxStatusV2Enum["danger"] = "danger";
    LuxStatusV2Enum["dark"] = "dark";
    LuxStatusV2Enum["subtle"] = "subtle";
    LuxStatusV2Enum["neutral"] = "neutral";
    LuxStatusV2Enum["flat"] = "flat";
    LuxStatusV2Enum["flatAlt"] = "flatAlt";
    LuxStatusV2Enum["brand"] = "brand";
    LuxStatusV2Enum["brandAlt"] = "brandAlt";
})(LuxStatusV2Enum || (LuxStatusV2Enum = {}));
export const LuxStatusKeys = Object.keys(LuxStatusEnum);
export const LuxStatusKeysV2 = Object.keys(LuxStatusV2Enum);
export var LuxSizeEnum;
(function (LuxSizeEnum) {
    LuxSizeEnum["xs"] = "xs";
    LuxSizeEnum["sm"] = "sm";
    LuxSizeEnum["md"] = "md";
    LuxSizeEnum["lg"] = "lg";
    LuxSizeEnum["xl"] = "xl";
})(LuxSizeEnum || (LuxSizeEnum = {}));
export const LuxSizeKeys = Object.keys(LuxSizeEnum);
export var LuxSurfaceEnum;
(function (LuxSurfaceEnum) {
    LuxSurfaceEnum["filled"] = "filled";
    LuxSurfaceEnum["outline"] = "outline";
    LuxSurfaceEnum["ghost"] = "ghost";
    LuxSurfaceEnum["ghostLink"] = "ghostLink";
})(LuxSurfaceEnum || (LuxSurfaceEnum = {}));
export const LuxSurfaceKeys = Object.keys(LuxSurfaceEnum);
export var LuxRoundedEnum;
(function (LuxRoundedEnum) {
    LuxRoundedEnum["none"] = "none";
    LuxRoundedEnum["xs"] = "xs";
    LuxRoundedEnum["sm"] = "sm";
    LuxRoundedEnum["md"] = "md";
    LuxRoundedEnum["lg"] = "lg";
    LuxRoundedEnum["xl"] = "xl";
    LuxRoundedEnum["full"] = "full";
})(LuxRoundedEnum || (LuxRoundedEnum = {}));
export const LuxRoundedKeys = Object.keys(LuxRoundedEnum);
export var LuxPaddingEnum;
(function (LuxPaddingEnum) {
    LuxPaddingEnum["none"] = "none";
    LuxPaddingEnum["xs"] = "xs";
    LuxPaddingEnum["sm"] = "sm";
    LuxPaddingEnum["md"] = "md";
    LuxPaddingEnum["lg"] = "lg";
    LuxPaddingEnum["xl"] = "xl";
})(LuxPaddingEnum || (LuxPaddingEnum = {}));
export const LuxPaddingKeys = Object.keys(LuxPaddingEnum);
//# sourceMappingURL=types.js.map